import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    get: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/associationOwners`,
        isArray: true
    },
    findById: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/associationOwners/:id`
    },
    deleteAssociationOwner: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/users/associationOwners/:associationOwnerId/ownershipAccount/:ownershipAccountId`
    },

    getAssociationOwnerByUserOwnershipId: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/associationOwners/ownerships/:userOwnershipId`
    },
    getOwnerOwnershipAccounts: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/associationOwners/ownerships`,
        isArray: true
    },
    getResidentVehicles: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/associationOwners/ownerships/:ownershipId/vehicles`,
        isArray: true
    },
    createResidentVehicle: {
        method: 'POST',
        url: `${BASE_PATH_API}/users/associationOwners/ownerships/:ownershipId/vehicles`
    },
    editResidentVehicle: {
        method: 'PUT',
        url: `${BASE_PATH_API}/users/associationOwners/ownerships/:ownershipId/vehicles/:id`
    },
    deleteResidentVehicle: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/users/associationOwners/ownerships/:ownershipId/vehicles/:id`
    },
    updateAssociationOwnerName: {
        method: 'PUT',
        url: `${BASE_PATH_API}/users/associationOwners/:associationOwnerId/name`
    },
    updateAssociationOwnerHeaderInfo: {
        method: 'PUT',
        url: `${BASE_PATH_API}/users/associationOwners/:associationOwnerId/headerInfo`
    },
    updateAssociationOwnerContactInfo: {
        method: 'PUT',
        url: `${BASE_PATH_API}/users/associationOwners/:associationOwnerId/contactInfo`
    },
    updateAssociationOwnerEmergencyContactInfo: {
        method: 'PUT',
        url: `${BASE_PATH_API}/users/associationOwners/:associationOwnerId/emergencyContactInfo`
    },
    updateAssociationOwnerPersonalInfo: {
        method: 'PUT',
        url: `${BASE_PATH_API}/users/associationOwners/:associationOwnerId/personalInfo`
    },
    getAssociationOwnerOwnershipAccounts: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/associationOwners/ownerships/:ownershipId/ownershipAccounts`,
        isArray: true
    },
    updateAssociationOwnerAftInfo: {
        method: 'PUT',
        url: `${BASE_PATH_API}/users/associationOwners/:associationOwnerId/aftInfo`
    },
    getAssociationOwnerAdoptionStatistics: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/associationOwners/adoptionStatistics`
    }
};

export function AssociationOwnersApi() {
    return createActions(actions);
}
